<template>
  <CallTargetNameItem
    v-if="info.type === 'callTargetName'"
    :title="info.item.title"
    :items="info.item.items"
    :node="info.item.node"
    :rules="info.item.rules"
    :loading="false"
    :value="info.item.value"
    uneditable
  />
  <LeadDetailListItem
    v-else
    :title="(info.item.title as string)"
    :value="info.item.value"
    :node="info.item.node"
    :rules="info.item.rules"
    :loading="false"
    :editable="false"
  />
</template>

<script lang="ts" setup>
import LeadDetailListItem from '@/components/organisms/user/lead/detail/LeadDetailListItem.vue';
import { type TLeadAttributeInfo } from '@/composable/user/lead/attributes';
import CallTargetNameItem from '../lead/detail/CallTargetNameItem.vue';

type TProps = {
  info: TLeadAttributeInfo;
};

defineProps<TProps>();
</script>
